interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
  iconBg: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '热点事件最快10分钟上线视频，全天候不间断更新，让你永远快人一步掌握最新吃瓜资讯。',
    iconBg: 'bg-primary-100 text-primary-500',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全平台支持1080P高清播放，自适应带宽优化。91吃瓜高清视频带来沉浸式观看体验。',
    iconBg: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '桌面端、移动网页、iOS和Android客户端无缝切换，91吃瓜在线观看随时随地不间断。',
    iconBg: 'bg-secondary-100 text-secondary-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全清爽',
    desc: '严格内容审核机制，无弹窗广告干扰，专注提供纯净流畅的91吃瓜在线播放体验。',
    iconBg: 'bg-primary-100 text-primary-500',
  },
  {
    icon: 'ri-folders-line',
    title: '资源大全',
    desc: '91吃瓜视频大全涵盖娱乐八卦、社会热点、网红动态等多维度内容，分类清晰查找便捷。',
    iconBg: 'bg-accent-100 text-accent-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">平台特色</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">为什么千万用户选择91吃瓜</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature) => (
            <div key={feature.title} className="bg-background-50 rounded-xl p-5 text-center">
              <div className={`w-12 h-12 mx-auto mb-4 rounded-xl flex items-center justify-center ${feature.iconBg}`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}